import { Outlet } from "react-router"
import {
	Stack,
	Tabs,
	TabsList,
	TabContent,
	Heading,
	Container,
} from "@sembark-travel/ui-base"
import { NavLink } from "@sembark-travel/ui-router"
import { generatePath } from "../../../../../router-utils"
import {
	FeatureFlag,
	PERMISSIONS,
	useCheckPermissions,
} from "../../../../../Auth"

export default function Layout() {
	const { hasPermission } = useCheckPermissions()
	return (
		<Stack gap="4">
			<Container>
				<Heading>Supplier Payment Preferences</Heading>
			</Container>
			<Tabs layout="col" gap="6">
				<TabsList>
					{hasPermission(PERMISSIONS.VIEW_HOTEL_SUPPLIERS) ? (
						<NavLink
							to={generatePath("/org/supplier-payment-preferences/hotel")}
						>
							Hotel
						</NavLink>
					) : null}
					{hasPermission(PERMISSIONS.VIEW_TRANSPORT_SERVICE_PROVIDERS) ? (
						<>
							<FeatureFlag flag="travel_activities">
								<NavLink
									to={generatePath(
										"/org/supplier-payment-preferences/activity"
									)}
								>
									Activity
								</NavLink>
							</FeatureFlag>
							<NavLink
								to={generatePath("/org/supplier-payment-preferences/transport")}
							>
								Transport
							</NavLink>
						</>
					) : null}
				</TabsList>
				<TabContent>
					<Outlet />
				</TabContent>
			</Tabs>
		</Stack>
	)
}
